import api from "./api";

export const getComments = async ()=> api.get(`/comments/getRecents`)

export const updateComment = comment => api.put(`/comments/updateComment`, comment)